import type React from 'react'
import './CrashPage.scss'
import Button from 'components/buttons/Button/Button'

const CrashPage: React.FC = () => {
  const handleReload = () => window.location.reload()

  return (
    <main>
      <div className="crash-page">
        <div className="cp-content">
          <span className="cp-subheader">Error</span>
          <h1 className="cp-title">
            Oops! Something
            <br />
            went wrong
          </h1>
          <p className="cp-text">
            This page has crashed. Our team has been notified. <br />
            If the issue continues, email us at <a href="mailto:contact@takecost.com">contact@takecost.com</a>
          </p>
          <Button type="primary" width="100px" onClick={handleReload}>
            Reload
          </Button>
        </div>
      </div>
    </main>
  )
}

export default CrashPage
